import React from 'react'
import { Text, View } from '../../other/html'
import Space from 'src/components/atoms/Space'
import CountryFlag from 'src/components/atoms/CountryFlag'
import { useMainDescription } from 'src/hooks/useVehicleDescription'
import { AgriculturalMachine, Camper, Motorbike, VehicleTypes, JetSki } from 'dealer-types'

interface Props {
  label1: string | undefined
  label2: string | undefined
  offerHashId: string
  zipCode: string | null
  place: string | null
  countryCode: string | null
  vehicleType: VehicleTypes
  vehicle: Motorbike | Camper | AgriculturalMachine | JetSki | undefined
}

const VehicleTitle = ({ label1, label2, place, zipCode, offerHashId, countryCode }: Props): JSX.Element => {
  const mainDescription = useMainDescription({ zipCode, place, countryCode })
  return (
    <>
      <View className="flex justify-between items-end w-full">
        <View>
          <Text fontWeight="Bold" style={{ fontSize: 20 }}>
            {label1}
          </Text>
          <Text fontWeight="Medium" fontSize="xl">
            {label2}
          </Text>
        </View>
      </View>
      <Space y={5} />
      <View className="flex items-center">
        <View className="flex justify-center items-center">
          <Text fontSize="l" fontWeight="Medium">
            {mainDescription}
          </Text>
          <Space x={1} />
          <CountryFlag countryCode={countryCode} />
        </View>
      </View>
    </>
  )
}

export default VehicleTitle
